module.exports = __webpack_public_path__ + "img/guotai.f09d9849.png";